import { getSettingsById } from '../../utils';
import { MODULE_NAME } from './constants';

const getSettings = () => getSettingsById(MODULE_NAME);

export default getSettings;
